import styled, { createGlobalStyle } from 'styled-components'
import { Drawer } from 'vaul'
import { CloseIcon } from '@velasca/icons/close'

export const GlobalStyle = createGlobalStyle`
  [data-vaul-drawer] {
    animation-duration: 0.2s;
  }
`

export const StyledOverlay = styled(Drawer.Overlay)`
  background: ${({ theme }) => theme.colors.modalShadow};
  /* For some unknown reason, children does not ineherit automatically those rules from the parent */
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1500;
`

export const StyledContent = styled(Drawer.Content)`
  // Double height to have a fallback on old browsers
  height: 75vh;
  height: 75dvh;
  width: 100%;
  background: ${({ theme }) => theme.colors.text.secondary};
  border-top-left-radius: 2rem;
  border-top-right-radius: 2rem;
  z-index: 1600;
  position: fixed;
  bottom: 0;

  @media (orientation: landscape) and (max-width: 991px) {
    height: 85vh;
    height: 100dvh;
  }
`

export const StyledCloseIcon = styled(CloseIcon)`
  path {
    color: ${({ theme }) => theme.colors.border};
  }
`

export const StyledClose = styled(Drawer.Close)`
  margin: 1rem;
  border: none;
  background: none;
  position: absolute;
  top: 0;
  right: 0;
`
